export const DASHBOARD_ROUTE = 'DASHBOARD_ROUTE';
export const LOGIN_ROUTE = 'LOGIN_ROUTE';
export const SIGNUP_PROFILE_ROUTE = 'SIGNUP_PROFILE_ROUTE';
export const SIGNUP_ORGANIZATION_ROUTE = 'SIGNUP_ORGANIZATION_ROUTE';
export const FORGOT_PASSWORD_ROUTE = 'FORGOT_PASSWORD_ROUTE';
export const SET_PASSWORD_ROUTE = 'SET_PASSWORD_ROUTE';
export const RESET_PASSWORD_ROUTE = 'RESET_PASSWORD_ROUTE';
export const VERIFY_EMAIL_ROUTE = 'VERIFY_EMAIL_ROUTE';
export const EMAIL_VERIFICATION_WALL_ROUTE = 'EMAIL_VERIFICATION_WALL_ROUTE';
export const ANNOUNCEMENTS_ROUTE = 'ANNOUNCEMENTS_ROUTE';
export const ADD_ANNOUNCEMENT_ROUTE = 'ADD_ANNOUNCEMENT_ROUTE';
export const EDIT_ANNOUNCEMENT_ROUTE = 'EDIT_ANNOUNCEMENT_ROUTE';
export const DUPLICATE_ANNOUNCEMENT_ROUTE = 'DUPLICATE_ANNOUNCEMENT_ROUTE';
export const DONATIONS_ROUTE = 'DONATIONS_ROUTE';
export const ADD_DONATION_ROUTE = 'ADD_DONATION_ROUTE';
export const EMAIL_ROUTE = 'EMAIL_ROUTE';
export const YURTZEITEN_ROUTE = 'YURTZEITEN_ROUTE';
export const YURTZEITEN_N_ROUTE = 'YURTZEITEN_N_ROUTE';
export const RECENT_PHOTO_ROUTE = 'RECENT_PHOTO_ROUTE';
export const TEXTS_ROUTE = 'TEXTS_ROUTE';
export const EVENTS_ROUTE = 'EVENTS_ROUTE';
export const EVENTS_N_ROUTE = 'EVENTS_N_ROUTE';
export const ADD_EVENT_ROUTE = 'ADD_EVENT_ROUTE';
export const EDIT_EVENT_ROUTE = 'EDIT_EVENT_ROUTE';
export const TICKETS_ROUTE = 'TICKETS_ROUTE';
export const MINYUNIM_ROUTE = 'MINYUNIM_ROUTE';
export const MINYANIM_N_ROUTE = 'MINYANIM_N_ROUTE';
export const MINYANIM_ROLLS_N_ROUTE = 'MINYANIM_ROLLS_N_ROUTE';
export const ADD_MINYANIM_ROLL_N_ROUTE = 'ADD_MINYANIM_ROLL_N_ROUTE';
export const EDIT_MINYANIM_ROLL_N_ROUTE = 'EDIT_MINYANIM_ROLL_N_ROUTE';
export const DUPLICATE_MINYANIM_ROLL_N_ROUTE = 'DUPLICATE_MINYANIM_ROLL_N_ROUTE';
export const ZMANIM_ROUTE = 'ZMANIM_ROUTE';
export const ZMANIM_N_ROUTE = 'ZMANIM_N_ROUTE';
export const ADD_ZMANIM_N_ROUTE = 'ADD_ZMANIM_N_ROUTE';
export const EDIT_ZMANIM_N_ROUTE = 'EDIT_ZMANIM_N_ROUTE';
export const DUPLICATE_ZMANIM_N_ROUTE = 'DUPLICATE_ZMANIM_N_ROUTE';
export const SETTINGS_ROUTE = 'SETTINGS_ROUTE';
export const ZMANIM_SETTINGS_ROUTE = 'ZMANIM_SETTINGS_ROUTE';
export const DATE_TIME_BANNER_ROUTE = 'DATE_TIME_BANNER_ROUTE';
export const DONATION_SETTINGS_ROUTE = 'DONATION_SETTINGS_ROUTE';
export const ANNOUNCEMENT_SETTINGS_ROUTE = 'ANNOUNCEMENT_SETTINGS_ROUTE';
export const RECENT_PHOTOS_SETTINGS_ROUTE = 'RECENT_PHOTOS_SETTINGS_ROUTE';
export const YURTZEITEN_SETTINGS_ROUTE = 'YURTZEITEN_SETTINGS_ROUTE';
export const DISPLAY_ROUTE = 'DISPLAY_ROUTE';
// The switching link: plays a screen schedule's member screens on its timetable.
export const SCREEN_SCHEDULE_DISPLAY_ROUTE = 'SCREEN_SCHEDULE_DISPLAY_ROUTE';
export const WEEKLY_EVENTS_ROUTE = 'WEEKLY_EVENTS_ROUTE';
export const ADD_WEEKLY_EVENT_ROUTE = 'ADD_WEEKLY_EVENT_ROUTE';
export const WEEKLY_EVENTS_SETTINGS_ROUTE = 'WEEKLY_EVENTS_SETTINGS_ROUTE';
// The Weekly Schedule engine: minyanim, shiurim and events by week. The list of
// the organization's weekly schedules, and one schedule's own page.
export const WEEKLY_SCHEDULE_N_ROUTE = 'WEEKLY_SCHEDULE_N_ROUTE';
export const WEEKLY_SCHEDULE_DETAILS_N_ROUTE = 'WEEKLY_SCHEDULE_DETAILS_N_ROUTE';
export const EVENTS_SETTINGS_ROUTE = 'EVENTS_SETTINGS_ROUTE';
export const PHOTO_UNDERLINES_ROUTE = 'PHOTO_UNDERLINES_ROUTE';
export const PUBLIC_SUBMISSION_ROUTE = 'PUBLIC_SUBMISSION_ROUTE';
export const YURTZEITEN_PUBLIC_FORM_ROUTE = 'YURTZEITEN_PUBLIC_FORM_ROUTE';
// The pre-shortening link shape, kept alive for QR codes already in the wild.
export const YURTZEITEN_PUBLIC_FORM_LEGACY_ROUTE =
  'YURTZEITEN_PUBLIC_FORM_LEGACY_ROUTE';

export const ERROR_ROUTE = 'ERROR_ROUTE';
export const NOT_FOUND_404_ROUTE = 'NOT_FOUND_404_ROUTE';

// The Screenkode admin's way in for a support session (utils/support_session).
export const SUPPORT_SESSION_ROUTE = 'SUPPORT_SESSION_ROUTE';
